<script>
  import { onMount } from 'svelte';
  // import { Router, Route, Link } from 'svelte-navigator'
  import Check from './Check.svelte'
  import Heading from './Heading.svelte'
  import Kramerius from './Kramerius.svelte';
  import Tasks from './Tasks.svelte'
  import List from './List.svelte'
  import { doLogin, getIssue } from './logic'
  import { page, logged, pagenum } from './stores'
  import Link from './Link.svelte'
  import Blocks from './Blocks.svelte'
  import Rubric from './Rubric.svelte'
  import Help from './Help.svelte';

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);  
  console.log('queryString', queryString);

  //let page = urlParams.get('op') || 'list'
  let userName = '', payload = ''
  // let logged = null
  let issueId = urlParams.get('id')
  let issue //= {"journalName":"Hlas lidu: Časopis hájící zájmy čtvrtého stavu","publisher":"Moric Vlach","releaseFrom":"1886 ","releaseDate":"9.1.1909","number":"3","year":"24","pagesUuid":["0116bde0-af47-11de-95f1-000d606f5dc6","24b49790-b708-11de-8dda-000d606f5dc6","0118b9b0-af47-11de-b016-000d606f5dc6","24b92b70-b708-11de-a253-000d606f5dc6","011bc6f0-af47-11de-b664-000d606f5dc6","24bbc380-b708-11de-81b6-000d606f5dc6","011d4d90-af47-11de-88ff-000d606f5dc6","24bed0c0-b708-11de-bd7a-000d606f5dc6"],"krameriusUuid":"c442b250-b722-11de-85ef-000d606f5dc6","pagesCount":8,"pagesHeight":[2324,2312,2332,2304,2317,2257,2279,2237],"pagesWidth":[1500,1500,1500,1500,1500,1500,1500,1500],"sourceDirname":"C:\\Users\\jakub\\Documents\\workspace\\asarp\\asarp-node\\data\\hlas_lidu\\1909\\00003","krameriusServer":"https://kramerius.mzk.cz","state":"articles","lastChange":"kontrola1","id":"hlas_lidu.1909.00003"}
  let modified = false
  let ishelp = false
  let error

  const pg = urlParams.get('pg')
  $pagenum = parseInt(pg)
 
  onMount(async () => {
    await doLogin('', '')
    await toPage()
  })

  async function login() {
    if (userName === '' || payload === '') return

    error = await doLogin(userName, payload)
    if (!error) {
      console.log('logged1',$logged)
      await toPage()
    }
  }

  const toPage = async () => {
    if ($logged && issueId && (!issue?.id !== issueId)) {
      issue = null
      console.log('toPage1', issue, $page)
      {({error, issue} = await getIssue(issueId))}
      console.log('toPage2', error, issue)
    } else {
      issue = {}
    }
  }

</script>
<!-- {JSON.stringify(issue)} {$pagenum} {$page} {$logged} -->
<main class="m-4">
  <div class="p-1 flex justify-between items-center border border-black bg-surface-100">
    <h1 class="text-2xl font-bold mr-2">ASARP</h1>
    {#if issue && $page !== 'list' && $page !== 'kramerius' && $page !== 'tasks'}<span class="header">
      <a href="https://www.digitalniknihovna.cz/mzk/view/uuid:{issue.krameriusUuid}" target="_blank">{issue.id}</a>
    </span>{/if}
    {#if $logged}<span class="login">login: {$logged} <Link class="mx-1" to="logout" bind:issue>odhlásit</Link></span>{/if}
  </div>

  {#if $logged && issue}
    {#if $page === 'heading'}
      <div class="flex justify-between items-center">
        <h2>Označení nadpisů</h2>
        <div class="grow ml-2 hover:anchor" on:click={() => ishelp = !ishelp}>{#if !ishelp}nápověda{:else}<span class="p-0.5 bg-tertiary-200">skrýt</span>{/if}</div>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          <a class="anchor mx-1" href="https://www.digitalniknihovna.cz/mzk/view/uuid:{issue.krameriusUuid}?page=uuid:{issue.pagesUuid[$pagenum-1]}" target="_blank">Kramerius</a>
        </nav>
      </div>
      <br/>
      {#if ishelp}<Help/>{/if}
      <Heading {issue} />
    {:else if $page === 'clean'}
      <div class="flex justify-between items-center">
        <h2>Čištění bloků</h2>
        <div class="grow ml-2 hover:anchor" on:click={() => ishelp = !ishelp}>{#if !ishelp}nápověda{:else}<span class="p-0.5 bg-tertiary-200">skrýt</span>{/if}</div>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          <a class="anchor mx-1" href="https://www.digitalniknihovna.cz/mzk/view/uuid:{issue.krameriusUuid}?page=uuid:{issue.pagesUuid[$pagenum-1]}" target="_blank">Kramerius</a>
        </nav>
      </div>
      <br/>
      {#if ishelp}<Help page="clean"/>{/if}
      <Blocks {issue} />
    {:else if $page === 'check'}
      <div class="flex justify-between items-center">
        <h2>Kontrola článků</h2>
        <div class="grow ml-2 hover:anchor" on:click={() => ishelp = !ishelp}>{#if !ishelp}nápověda{:else}<span class="p-0.5 bg-tertiary-200">skrýt</span>{/if}</div>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          {#if !modified}<Link class="mx-1" to="rubric" line={issue} keep>Rubriky</Link>{/if}
          <a class="anchor mx-1" href="https://www.digitalniknihovna.cz/mzk/view/uuid:{issue.krameriusUuid}?page=uuid:{issue.pagesUuid[$pagenum-1]}" target="_blank">Kramerius</a>
        </nav>
      </div>
      <br/>
      {#if ishelp}<Help page="check"/>{/if}
      <Check {issue} bind:modified />
    {:else if $page === 'rubric'}
      <div class="flex justify-between items-center">
        <h2>Přiřazení rubrik</h2>
        <div class="grow ml-2 hover:anchor" on:click={() => ishelp = !ishelp}>{#if !ishelp}nápověda{:else}<span class="p-0.5 bg-tertiary-200">skrýt</span>{/if}</div>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          {#if !modified}<Link class="mx-1" to="check" line={issue} keep>Články</Link>{/if}
          <a class="anchor mx-1" href="https://www.digitalniknihovna.cz/mzk/view/uuid:{issue.krameriusUuid}?page=uuid:{issue.pagesUuid[$pagenum-1]}" target="_blank">Kramerius</a>
        </nav>
      </div>
      <br/>
      {#if ishelp}<Help page="rubric"/>{/if}
      <Rubric {issue} bind:modified />
    {:else if $page === 'kramerius'}
      <div class="flex justify-between items-center">
        <h2>Získání ročníku / čísla z Krameria</h2>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          <Link class="mx-1" to="tasks">Úlohy</Link>
        </nav>
      </div>
      <br/>
      <Kramerius user={logged} />
    {:else if $page === 'tasks'}
      <div class="flex justify-between items-center">
        <h2>Plánované úlohy</h2>
        <nav>
          <Link class="mx-1" to="list">Seznam</Link>
          <Link class="mx-1" to="kramerius">Získat</Link>
        </nav>
      </div>
      <br/>
      <Tasks />
    {:else if $page === 'list'}
      <div class="flex justify-between items-center">
        <h2>Seznam zpracovaných čísel</h2>
        <nav>
          <Link class="mx-1" to="kramerius">Získat</Link>
          <Link class="mx-1" to="tasks">Úlohy</Link>
        </nav>
      </div>
      <br/>
      <List bind:issue />
    {/if}
  {:else}
    <div class="m-5 space-y-3">
      <p class="font-semibold">Přihlášení:</p>
      <input class="input" type="text" bind:value={userName} />
      <input class="input" type="password" bind:value={payload} />
      <input class="btn btn-green" type="button" value="login" on:click|preventDefault={login} />
      {#if error}<span class="error">{error}</span>{/if}
    </div>
  {/if}
</main>

<style>
  .error {
    color: red;
    margin-left: 0.5em;
  }

  h2 {
    font-size: larger;
    font-weight:600;
  }

</style>